/**
 * 슈퍼관리자(플랫폼) 권한 키 — admin 쪽 «검사된» 사본.
 *
 * ⚠️ **정본은 server `ADMIN_PERMISSION_KEYS` · 동기화는 `__tests__/adminPermissionKeys.guard.test.ts`가 잰다 ·
 * 키를 더하거나 빼면 두 곳 다 고친다**(한쪽만 고치면 그 가드가 red — 그때 기대값을 맞추지 말고 빠진 쪽을 고쳐라).
 *
 * **정본은 서버 `apps/server/src/admin/admin.constants.ts`의 `ADMIN_PERMISSION_KEYS`다.** admin은 서버
 * 모듈을 import할 수 없고 그 배열은 shared에 없어서 사본을 둔다. 사본이 정본과 갈라지면
 * `__tests__/adminPermissionKeys.guard.test.ts`가 red다(서버 파일 «텍스트»를 읽어 대조한다 — admin tsc는
 * 서버 파일을 보지 않고 CI도 admin tsc를 돌리지 않으므로 그 축의 탐지기는 그 가드 하나다).
 *
 * 이 사본이 있는 이유는 **타입**이다 — 권한 라벨 맵(`Roles.tsx`)을 `Record<AdminPermissionKey, string>`으로
 * 두면 키를 더했는데 라벨을 안 단 상태가 admin tsc red가 된다(종전 `Record<string, string>`이라
 * `monitoring-view`·`report-builder`·`legal-obligation-catalog` 셋이 라벨 없이 키 문자열로 보였다).
 *
 * ⚠️ 조직(회사) 권한 키(`@safetyhub/shared`의 `PermissionKey`)와 **다른 축**이다 — 섞지 말 것.
 */
export const ADMIN_PERMISSION_KEYS = [
  'dashboard',
  'organization-management',
  'user-management',
  'feedback',
  'impersonation',
  'ai-settings',
  'sms-monitoring',
  'system-settings',
  'admin-management',
  'monitoring-view',
  'report-builder',
  'legal-obligation-catalog',
] as const;

export type AdminPermissionKey = (typeof ADMIN_PERMISSION_KEYS)[number];

/** 런타임 문자열(서버 응답)을 좁힌다 — 정본 밖 키가 오면 false(라벨 대신 키 문자열을 보인다) */
export function isAdminPermissionKey(key: string): key is AdminPermissionKey {
  return (ADMIN_PERMISSION_KEYS as readonly string[]).includes(key);
}
